import { DefaultDialog } from "@graffer-inc/console-design-kit";
import dayjs from "dayjs";
import { Formik, FormikProps } from "formik";
import { useProductDataRemovalTaskCreateForm } from "./form/hooks";
import {
  ProductDataRemovableProductCodeLiterals,
  ProductDataRemovalTask,
} from "../../../../../application/domain/product-data-removal-task";
import {
  ProductDataRemovalTaskForm,
  ProductDataRemovalTaskFormValues,
} from "./form/product-data-removal-task-form";

type ProductDataRemovalTaskApproveModalProps = {
  productCode: ProductDataRemovableProductCodeLiterals;
  tenantSlug: string;
  task: ProductDataRemovalTask;
  onProceed: (task: ProductDataRemovalTask) => void;
  onCancel: () => void;
};

export const ProductDataRemovalTaskApproveModal = ({
  productCode,
  tenantSlug,
  task,
  onProceed,
  onCancel,
}: ProductDataRemovalTaskApproveModalProps) => {
  const { validationSchema, dateConfig } = useProductDataRemovalTaskCreateForm({
    tenantSlug,
    disableDateRangeValidation: true,
  });

  const initialValues: ProductDataRemovalTaskFormValues = {
    dueAt: dayjs(task.dueAt).format(dateConfig.DateFormat),
    slug: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={() => {
        onProceed(task);
      }}
      validateOnChange={true}
      validateOnMount={true}
      enableReinitialize={true}
      validateOnBlur={true}
    >
      {(formikProps: FormikProps<ProductDataRemovalTaskFormValues>) => {
        const { isValid, submitForm } = formikProps;

        return (
          <DefaultDialog
            title="製品データ削除タスクの承認"
            proceedText="承認する"
            cancelText="やめる"
            proceedDisabled={!isValid}
            onProceed={submitForm}
            onCancel={onCancel}
            contents={
              <ProductDataRemovalTaskForm
                productCode={productCode}
                tenantSlug={tenantSlug}
                dueAtConfig={{ readOnly: true }}
                formikProps={formikProps}
              />
            }
          />
        );
      }}
    </Formik>
  );
};
